<template>
	<Modal 
	title="GERAR QRCODE PARA NOVA CONEXÃO"
	:loading="loading"
	@close="close"
	@save="save">		
		<div v-if="currentQRCode == false" class="row">
			<div class="col-xs-12 aling-item">
				<span class="loading-icon"><i class="fas fa-circle-notch fa-spin"></i></span>
			</div>
		</div>
		<div v-else class="row">
			<div class="col-xs-12 aling-item">
                <small>QR Code</small>
            </div>
			<div class="col-xs-12 aling-item">
				<img class="img-qr-code" :src="currentQRCode.qr" />
            </div>
            <div class="col-xs-12 aling-item">
                <small>Login Request ID</small>
            </div>
			<div class="col-xs-12 aling-item">
				{{ currentQRCode.requestID.trim() }}
            </div>
        </div>
	</Modal>
</template>

<script>
import Api from "@/lib/Api";

import Modal from "@/components/Modal";

export default {
	name: "AdminSettingQRCode",

	props: [ "current" ],

	components: { Modal },

	data: function() {
		return {
            loading: false,
			currentQRCode: false,
			interval: false,
        };
	},

	mounted: function() {
		this.load();
		
		this.interval = setInterval(() => {
			this.currentQRCode = false;
			this.load();
		}, 10000);
	},

	methods: {
		load: async function() {
			let response = null;
            try {
                response = await Api.post_admin("setting/get-qr-code");
            } catch (ex) {
                console.log(ex);
                this.$notification.error("Não foi possível verificar o status da conexão.");
                return;
            }
            
            if (response.error) {
                this.$notification.error(response.data);
                return;
            }
			
			this.currentQRCode = response.data;
		},

        // Salva a instância atual
		save: async function() {
            this.loading = true;

            let value = JSON.parse(this.current.value);
            
            value.forEach(element => {
                if (element.name == "login_request_id") {
                    element.value = this.currentQRCode.requestID.trim();
                }
            });
            
            this.current.value = JSON.stringify(value);
            
            this.$parent.verifyStatusLogin(this.current);

            this.loading = false;
			this.close();
		},
        
        // Fecha o modal
		close: function() {
			clearInterval(this.interval);
            this.$parent.showQRCode = false;
			this.$parent.current = false;
		}
	},
}
</script>

<style scoped>
.loading-icon {
	font-size: 50px;
	padding: 15px 0;
}

.aling-item {
    text-align: center;
}

.img-qr-code {
	border: 1px solid black;
    border-radius: 3px;
    margin-bottom: 30px;
}
</style>